export const environment = {
    production: true,
    pbmUrl: "https://pbm.npd-at.postnord.com", 
    airapikey:'k6cvyhKgB4kS4ROWkNcNMdih1596qNUd',
    airApiUri:'https://air-test.pgm.postnord.com/',
    pnBaseLayerUrl : 'https://tiles-prod.pgm.postnord.com/styles/postnord-basemap/{z}/{x}/{y}.png',
    kpiurl: 'https://dp-at.postnord.com/dp/routeinfo?daysoffset=0&blid=1007350&delta=false',
    unplannedurl: 'https://dp-at.postnord.com/dp/tasks/unplanned?blid=1007350&status=unplanned&daysoffset=0&delta=false',
    redirectUri: 'https://dp-at.postnord.com/login',
    postLogoutRedirectUri: 'https://dp-at.postnord.com/login',
    businessLocationurl : 'https://dp-at.postnord.com/v4/businesslocations',
    routebundle:'https://dp-at.postnord.com/v4/routebundles',
    baseUrl: 'https://dp-at.postnord.com/',
    ProductionBookingUrl: 'https://pbm.npd-at.postnord.com/#/',
    wspUrl : 'https://wsp.npd-at.postnord.com/#/',
    ndmwebUrl :'https://ndm-at.postnord.com/#/',
    adminUrl:'https://admin.npd-at.postnord.com/#/',
    pathDP: 'dp/',
    pathV4: 'v4/',
    pathV1 : 'v1/',
    pathRPS: "rps/",
    pathAddress : 'address',
    


    plannedurl : 'https://dp-at.postnord.com/dp/tasks?routeid=f5e63d52-2ea2-3164-80c2-fc990c1ff503&daysoffset=0&delta=false',

    appInsights: {
        instrumentationKey: 'instrumentationKey=71242b6f-b557-4691-a627-ded0b7394977'
    },
    msalConfig: {
        auth: {
            clientId: '8f36e472-1244-417c-acf8-27742a372102',
            authority: 'https://login.microsoftonline.com/91f09566-a850-4fae-bbe1-29ad3804a2f6',
        }
    },
    apiConfig: {
        scopes: ['openid', 'profile'],
        uri: 'https://graph.microsoft.com/v1.0/me',
        apirooturi: "https://dp-at.postnord.com/dp/",
        apirootV4Uri: "https://dp-at.postnord.com/v4/",
        apirootAddressUri: "https://dp-at.postnord.com/address/",
        apirootRPSUri: "https://dp-at.postnord.com/rps/"
    }
};
